import { Theme as AugmentedTheme } from '@mui/material';

import { makeStyles } from 'tss-react/mui';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Button,
  ContentTemplate,
  CustomSelect,
  HeaderInput,
  HeaderTemplate,
  Progress,
} from 'web-library';
import { AUTHORITY_NAMES } from 'web-library/models/AuthorityFunctions';
import { useGetAuditSettingsReportTypes } from '../../api-refactored/audit-settings/useGetAuditSettingsReportTypes';
import { useGetRetrieveAuditSettings } from '../../api-refactored/audit-settings/useGetRetrieveAuditSettings';
import { useGetUserAuthorities } from '../../api-refactored/user/useGetUserAuthorities';
import AdminAuditSettings from '../../modules/admin/components/AdminAuditSettings';
import { configurationTypeData } from '../../modules/admin/logic/dropDownOption';

const useStyles = makeStyles()((theme) =>
({
  buttonApply: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(6),
  },
}));

const AuditSettingsDetails = () => {
  const { t } = useTranslation();
  const { classes } = useStyles();

  const [isSuccessReportTypes, setIsSuccessReportTypes] = useState<boolean>(false);
  const [isSuccessRetrieveAuditSettings, setIsSuccessRetrieveAuditSettings] = useState<boolean>(
    false
  );
  const [requestInput, setRequestInput] = useState<string>(
    'FAILED_PRIVILEGED_LOGIN_ATTEMPTS_REPORT'
  );

  const { data: userAuthoritiesData = [] } = useGetUserAuthorities();
  const isEnableEdit = userAuthoritiesData.includes(AUTHORITY_NAMES.CP_ADMIN_AUDIT_SETTINGS_EDIT);

  const { data: reportTypesData } = useGetAuditSettingsReportTypes({
    onSuccess: (res) => {
      if (res.length) {
        setRequestInput(res[0].code);
      }
      setIsSuccessReportTypes(true);
    },
  });

  const {
    data: auditSettingsData,
    refetch: refetchRetrieveAuditSettings,
  } = useGetRetrieveAuditSettings({
    reportType: requestInput,
    onSuccess: () => {
      setIsSuccessRetrieveAuditSettings(true);
    },
  });

  const applySelectionClick = () => {
    setIsSuccessRetrieveAuditSettings(false);
    refetchRetrieveAuditSettings();
  };

  const reportTypesDataCustomSelect = configurationTypeData(reportTypesData || []);

  const renderAuditSettings = () =>
    isSuccessRetrieveAuditSettings ? (
      <AdminAuditSettings
        auditSettingsData={auditSettingsData || undefined}
        requestType={requestInput}
        isEnableEdit={isEnableEdit}
        reportTypesData={reportTypesData}
      />
    ) : (
      <Progress color="secondary" />
    );

  return (
    <>
      {isSuccessReportTypes ? (
        <>
          <HeaderTemplate>
            <HeaderInput
              label={t('admin->>AuditSettings.ReportName')}
              input={
                <CustomSelect
                  defaultValue="FAILED_PRIVILEGED_LOGIN_ATTEMPTS_REPORT"
                  menuItems={reportTypesDataCustomSelect}
                  placeholder="Select Report"
                  onChange={(event) => {
                    setRequestInput(event.target.value as string);
                  }}
                  variant="filled"
                  isHeader
                />
              }
            />
            <Button
              id="button-apply-selection"
              className={classes.buttonApply}
              onClick={applySelectionClick}
            >
              {t('admin->>AuditSettings.ApplySelection')}
            </Button>
          </HeaderTemplate>
          <ContentTemplate>{renderAuditSettings()}</ContentTemplate>
        </>
      ) : (
        <HeaderTemplate>
          <Progress color="secondary" />
        </HeaderTemplate>
      )}
    </>
  );
};

export default AuditSettingsDetails;
